import React from 'react';
import Header from '../../components/Header';
import FooterTwo from '../../components/Footer/FooterTwo';
import Breadcrumb from '../../components/Breadcrumb';
import ScrollToTop from '../../components/ScrollTop';
import AboutMain from './AboutMain';
import service from '../../services/aboutus';
import Logo from '../../assets/images/logos/logo2.png';
import { useState } from 'react';
import { useEffect } from 'react';

const About = () => {
    const [data,setData]=useState(null);

    useEffect(()=>{
        service.get().then(res=>setData(res.data[0])).catch(err=>console.log(err));
    },[]);

    return (
        <>
            <Header
                parentMenu='page'
                menuCategoryEnable='enable'
                // headerNormalLogo={Logo}
                // headerStickyLogo={Logo}
                topbarEnable='enable'
            />

            <div class="react-wrapper">
                <div class="react-wrapper-inner">
                    <Breadcrumb pageTitle="About OCFIT" />
                    <AboutMain data={data}/>
                    <ScrollToTop />
                </div>
            </div>

            <FooterTwo />

        </>
    );
}

export default About;